import Window from './window';

/* eslint-disable import/prefer-default-export */
/* eslint-disable dot-notation */
export function getLocation() {
  const { location } = Window;
  return `${location.protocol}//${location.hostname}${
    location.port ? `:${location.port}` : ''
  }`;
}

export function getOidcClientId() {
  return Window['config'].REACT_APP_OIDC_CLIENTID;
}

export function getOidcScope() {
  return Window['config'].REACT_APP_OIDC_SCOPE;
}

export function getOidcAuthority() {
  return Window['config'].REACT_APP_OIDC_AUTHORITY;
}

export function getOidcToken() {
  return Window['config'].REACT_APP_OIDC_TOKEN;
}

export function getOidcApiRoot() {
  const root = Window['config'].REACT_APP_API_ROOT;
  return !root || root === 'undefined' || root === undefined
    ? getLocation()
    : root;
}

export function getOidcClientRoot() {
  const root = Window['config'].REACT_APP_CLIENT_ROOT;
  return !root || root === 'undefined' || root === undefined
    ? getLocation()
    : root;
}

export function getAdobeAnalyticsLibrary() {
  return Window['config'].ADOBE_ANALYTICS_LIBRARY;
}

export function getAdobeAnalyticsPlugin() {
  return Window['config'].ADOBE_ANALYTICS_PLUGIN;
}

export function getAdobeAnalyticsLayer() {
  return Window['config'].ADOBE_ANALYTICS_LAYER;
}

export function getDsmTokens() {
  return Window['config'].DSM_TOKENS;
}

export function getLogRocketId() {
  return Window['config'].LOG_ROCKET_ID;
}

export function getAdyenClientKey() {
  return Window['config'].ADYEN_CLIENT_KEY;
}

export function getAdyenEnvironment() {
  return Window['config'].ADYEN_ENVIRONMENT;
}

export function getRazorpayApiKey() {
  return Window['config'].RAZORPAY_API_KEY;
}

export function getEnv() {
  const location: string = getOidcClientRoot();
  if (location.includes('int.pmi.org') || location.includes('localhost:')) {
    return 'int';
  }
  if (location.includes('qa.pmi.org')) {
    return 'qa';
  }
  if (location.includes('candidate.pmi.org')) {
    return 'candidate';
  }
  return 'prod';
}

export function getPMISiteUrl(prefix = 'www') {
  const env = getEnv();

  if (env === 'int') {
    return `https://${prefix}.erpint.pmi.org`;
  }
  if (env === 'qa') {
    return `https://${prefix}.erpqa.pmi.org`;
  }
  if (env === 'candidate') {
    return `https://${prefix}.candidate.pmi.org`;
  }
  return `https://${prefix}.pmi.org`;
}

export function getPartnerUrl() {
  const env = getEnv();

  if (env === 'int' || env === 'qa' || env === 'candidate') {
    return `https://partner.${env}.pmi.org`;
  }
  return 'https://partner.pmi.org';
}

export function getSelfServiceUrl() {
  const env = getEnv();

  if (env === 'int' || env === 'qa' || env === 'candidate') {
    return `https://orders.${env}.pmi.org`;
  }
  return 'https://orders.pmi.org';
}

export function getMyPMISiteUrl() {
  return getPMISiteUrl('my');
}
